import { z } from '@lucidlink/dto/z';
import { inviteEmailFiltersValidator } from '../../../../MembersEmailsTagInput/services/validation';
import { INVITE_TYPES } from '../../constants/invite-members.constants';
export const createIndividualInvitationFormParser = z.object({
    type: z.literal(INVITE_TYPES.individual),
    emailFilters: inviteEmailFiltersValidator,
    groups: z.array(z.string()),
});
